import { render, staticRenderFns } from "./PersonalAccounts.vue?vue&type=template&id=5d33e66f&"
import script from "./PersonalAccounts.vue?vue&type=script&lang=js&"
export * from "./PersonalAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports